import Shipment from "../Models/Shipment";
import {Customer} from "../Models/Customer";
import Receiver from "../Models/Receiver";
import {formatDDMMYYY, getAddress, getModelName} from "./Utils";
import Address from "../Models/Address";


export const clientFormat = (cell: any, row: Shipment) => {
  if (row.customer_to_bill && typeof row.customer_to_bill !== "string" && Object.keys(row.customer_to_bill).length > 0) {
    return getModelName(row.customer_to_bill as Customer);
  }
  return getModelName(row.customer as Customer);
}

export const addressFormat = (cell: any, shipment: Shipment) => {
  if (shipment.delivery_branch) {
    return getAddress(shipment.delivery_address as Address);
  }
  return getAddress(shipment.pickup_address as Address);
}

export const receiverFormat = (cell: any, row: Shipment) => (
  ` ${(row.receiver as Receiver).name}
      ${(row.receiver as Receiver).last_name}`
)

export const metaFormat = (cell: any, row: Shipment) => (` ${formatDDMMYYY(new Date(row._META.created_time))}`)
